import * as React from 'react';
import { css } from 'styled-components';
import {
  mediaQueries,
  setFontFormat,
  titleWeight,
  setFontSizeByModule
} from 'src/components/common/utils/component-styles';
import Layout from 'src/components/common/theme/Layout';
import { ModuleProps } from 'src/components/common/utils/module-util';
import { checkValue } from 'src/components/common/helper';
import { spacingSeter } from 'src/components/common/theme/component-styles';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';


const CpCmsLiteContent = (props: ModuleProps) => {
  const {
    defaultSetting: { style },
    data: {
      description: paragraphDesktop,
      descriptionCopySizeDesktop,
      descriptionCopySizeMobile,
      descriptionCopyWeight,
      headline,
      module,
      moduleCopyColor,
      showModuleDivider,
      moduleStyle = 'text-left',
      topPadding,
      bottomPadding,
      moduleVariation = "Style-1",
      headlineColor="",
      paragraphColor="",
      backgroundColor="",
      moduleDividerColor="",
      paragraphMobile = ""
    },
  } = props;

  const { width: windowWidth } = useWindowDimensions();
  const description = windowWidth < 768 && checkValue(paragraphMobile) ? paragraphMobile : paragraphDesktop;
  const isModuleSeparator = checkValue(showModuleDivider) && showModuleDivider === 'True' ? true : false;

  const moduleCss = () => {
    const descriptionCopySizeDesktopMap = setFontSizeByModule(
      module,
      'descriptionCopySizeDesktop',
      descriptionCopySizeDesktop
    );
    const descriptionCopySizeMobileMap = setFontSizeByModule(
      module,
      'descriptionCopySizeMobile',
      descriptionCopySizeMobile
    );
    const getModuleCopyColor = checkValue(moduleCopyColor) ? moduleCopyColor : '';
    const getModuleSeparatorColor = checkValue(moduleDividerColor) ? moduleDividerColor : '';

    return `  
              ${moduleVariation !== 'Style-4' ? `
                .content{
                  @media only screen and (min-width: 575px) {
                    ${spacingSeter('padding-top', topPadding)};
                    ${spacingSeter('padding-bottom', bottomPadding)};
                  }
                }` : ''
              }                                          
              ${setFontFormat(
                '.content p',
                descriptionCopySizeDesktopMap,
                titleWeight(descriptionCopyWeight),
                getModuleCopyColor
              )}            
              .content-module {
                    ${
                      isModuleSeparator
                        ? getModuleSeparatorColor !== ''
                          ? `border-bottom: 8px solid ${getModuleSeparatorColor} !important;`
                          : ''
                        : `border-bottom: 0px !important;`
                    },
                                         
              };       
              @media only screen and (max-width: ${mediaQueries.tab}) {                                            
                ${setFontFormat(
                  '.content p',
                  descriptionCopySizeMobileMap,
                  titleWeight(descriptionCopyWeight),
                  getModuleCopyColor
                )}              
              }
              
              ${checkValue(headlineColor) ? `
                &.content-section{
                  .content-module h2.cms-typo {
                    color:${headlineColor} !important;
                  }
                }
              ` : ""}   
              
              ${checkValue(paragraphColor) ? `
              &.content-section{
                .content-module p.cms-typo {
                  color:${paragraphColor} !important;
                }
              }
            ` : ""}  

            ${checkValue(backgroundColor) ? `
            &.content-section{
              .content {
                background-color:${backgroundColor} !important;
              }
            }
          ` : ""}  
            `;
  };
  return (
    <>
      {(checkValue(headline) || checkValue(description)) && (
        <Layout
          className={`content-section ${moduleVariation}`}
          css={css`
            ${moduleCss()}
          `}
          HtmlTag="section"          
        >
          <div className="content content-webflow">
            <div
              className={`content-module content-module--${
                checkValue(moduleStyle) ? moduleStyle.toLowerCase() : `text-left`
              } ${!isModuleSeparator ? `noseperator` : ``}`}
            >
              {/* {checkValue(headline) && <h2>{headline}</h2>} */}
              {checkValue(headline) && <h2 className='cms-typo override-heading-font-family' dangerouslySetInnerHTML={{ __html: headline }} />}
              {checkValue(description) && <p className='cms-typo' dangerouslySetInnerHTML={{ __html: description }} />}
            </div>
          </div>
        </Layout>
      )}
    </>
  );
};

export default CpCmsLiteContent;
